export default __webpack_public_path__ + "static/media/travel1.2619fa06.jpg";